import { Component, OnInit, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'lib-active-vehicles-count',
    templateUrl: './active-vehicles-count.component.html',
    styleUrls: ['./active-vehicles-count.component.scss'],
    imports: [DecimalPipe]
})
export class ActiveVehiclesCountComponent implements OnInit {
  @Input() count;
  @Input() resultText;

  constructor() {}

  ngOnInit() {}
}
